export const ORG_REGISTRIES_RESET_STATE = 'ORG_REGISTRIES_RESET_STATE';
export const ORG_REGISTRIES_CURRENT_ITEM = 'ORG_REGISTRIES_CURRENT_ITEM';
 
export const ORG_REGISTRIES_REQUEST_LOADING = 'ORG_REGISTRIES_REQUEST_LOADING';
export const ORG_REGISTRIES_REQUEST_SUCCESS = 'ORG_REGISTRIES_REQUEST_SUCCESS';
export const ORG_REGISTRIES_REQUEST_FAILED = 'ORG_REGISTRIES_REQUEST_FAILED';
 
export const ORG_REGISTRIES_CURRENT_ACTION = 'ORG_REGISTRIES_CURRENT_ACTION';
export const ORG_REGISTRIES_RESET_ACTION = 'ORG_REGISTRIES_RESET_ACTION';